<ng-template #templateRef>
    <h2 mat-dialog-title class="flex-grow-0">{{data.Title}}</h2>
    <mat-dialog-content class="flex-grow-1"><p [innerHTML]="data.Message"></p></mat-dialog-content>
    <mat-dialog-actions class="flex-grow-0">
        <div class="fill-remaining-space"></div>
        <button mat-button mat-raised-button (click)="close(false)">No</button>
        <button mat-button mat-raised-button (click)="close(true)" color="primary">Yes</button>
    </mat-dialog-actions>
</ng-template>